import { useMotionValueEvent, useScroll } from 'framer-motion';
import { RefObject, useRef } from 'react';

export default function useLoadMoreData(
  ref: RefObject<HTMLDivElement>,
  key: string,
  onLoadMore: () => void
) {
  const currentKeyRef = useRef(key);
  currentKeyRef.current = key;

  const keysLoadedRef = useRef<string[]>([]);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ['start end', 'end end']
  });

  useMotionValueEvent(scrollYProgress, 'change', (progress) => {
    const containerHeight = ref.current?.offsetHeight;
    if (containerHeight) {
      const trigger = 1 - window.innerHeight / 2 / containerHeight;
      if (
        progress > trigger &&
        !keysLoadedRef.current.includes(currentKeyRef.current)
      ) {
        try {
          onLoadMore?.();
          keysLoadedRef.current.push(currentKeyRef.current);
        } catch (err) {
          // silent error
        }
      }
    }
  });
}
